import ViewBase from "../../../../framework/core/mvvm/view_base";

const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu('custom/public/PokerTableFrameView')
export default class PokerTableFrameView extends ViewBase {
    @property(cc.Node)
    nodeMenuRoot: cc.Node = null

    @property(cc.Node)
    nodeMask: cc.Node = null

    @property(cc.Node)
    nodeCloseBtn: cc.Node = null
    @property(cc.Node)
    nodeOpenBtn: cc.Node = null

    @property(cc.Node)
    nodeLeaveBtn: cc.Node = null

    @property(cc.Node)
    nodeSettingBtn: cc.Node = null

    @property(cc.Node)
    nodeRuleBtn: cc.Node = null

    @property(cc.Node)
    nodeRuleExplainBtn: cc.Node = null
    
    @property(cc.Node)
    nodeIntrustBtn: cc.Node = null

    @property(cc.Node)
    nodeFreeRoomBtn: cc.Node = null

    @property(cc.Node)
    nodeTime: cc.Node = null
    @property(cc.Label)
    timeLabel: cc.Label = null    

    @property(cc.Node)
    nodeRoomInfo: cc.Node = null

    @property(cc.Label)
    roomNumLable: cc.Label = null

    @property(cc.Node)
    myMatchInfoRoot: cc.Node = null

    @property(cc.RichText)
    myMatchRankLabel: cc.RichText = null

    @property(cc.Label)
    kickOutLabel: cc.Label = null

    @property(cc.Node)
    tableRankBtnNode: cc.Node = null




    showMenu(show: boolean){
        this.nodeMenuRoot.active = show
    }

    showFreeRoomBtn(show: boolean){
        this.nodeFreeRoomBtn.active = show
    }

    showOpenBtn(show: boolean){
        this.nodeOpenBtn.active = show
    }

    showCloseBtn(show: boolean){
        this.nodeCloseBtn.active = show
    }

    showLeaveBtn(show: boolean){
        this.nodeLeaveBtn.active = show
    }

    showIntrustBtn(show: boolean){
        this.nodeIntrustBtn.active = show
    }

    showSettingBtn(show: boolean){
        this.nodeSettingBtn.active = show
    }

    showRuleBtn(show: boolean){
        this.nodeRuleBtn.active = show
    }

    showRoomInfo(show: boolean, roomId: number){
        this.nodeRoomInfo.active = show
        if(show){
            this.roomNumLable.string = '房号:' + roomId
        }
    }

    showTime(show: boolean){
        this.nodeTime.active = show
    }

    refreshTime(){
        let nowDate = new Date(Date.now())
        this.timeLabel.string = nowDate.getHours() + ':' + nowDate.getMinutes()
    }
    

}
